import React, { useState } from "react";
import axios from "../../api/axios";
import { useNavigate } from "react-router-dom";

const ADD_MEAL_URL = "/api/product/add";
const UPLOAD_LOGO_URL = "/api/product/upload/";

function AddMeal() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        category: "",
        price: "",
        logo: null,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, logo: e.target.files[0] });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const { logo, ...mealData } = formData;
            const mealResponse = await axios.post(ADD_MEAL_URL, mealData);

            const mealId = mealResponse.data._id;
            let logoUrl = "";

            if (formData.logo) {
                const fileData = new FormData();
                fileData.append("file", formData.logo);

                const uploadResponse = await axios.put(`${UPLOAD_LOGO_URL}${mealId}`, fileData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                logoUrl = uploadResponse.data.logoUrl;
            }

            navigate('/menu');
            setFormData({ name: "", category: "", price: "", logo: null });
        } catch (error) {
            console.error("Error adding meal:", error);
            alert("Failed to add meal");
        }
    };

    return (
        <div className="max-w-5xl mx-auto p-10 bg-white rounded-lg shadow-lg transition duration-300 hover:shadow-2xl">
            <h2 className="text-4xl font-bold mb-8 text-[#4335A7] text-center">Add a Meal or Drink</h2>
            <form onSubmit={handleSubmit} className="space-y-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="flex flex-col">
                        <label htmlFor="name" className="text-lg font-medium text-[#2c3e50] mb-2">Meal/Drink Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter Meal or Drink Name"
                            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4335A7] transition duration-200 shadow-lg"
                            required
                        />
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="category" className="text-lg font-medium text-[#2c3e50] mb-2">Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4335A7] transition duration-200 shadow-lg"
                            required
                        >
                            <option value="">Select Category</option>
                            <option value="TEA">THÉ / TEA</option>
                            <option value="COFFEE">CAFÉ / COFFEE</option>
                            <option value="JUICE">JUS / JUICE</option>
                            <option value="MOCKTAILS">MOCKTAILS</option>
                            <option value="WATERS">EAUX ET SODAS / WATERS & SODAS</option>
                            <option value="BEER">BIÈRE / BEER</option>
                            <option value="SALAD">SALADE / SALAD</option>
                            <option value="BURGER">BURGER</option>
                            <option value="SANDWICH">SANDWICH</option>
                            <option value="OMELETTE">OMELETTE</option>
                            <option value="PLATS">PLATS</option>
                            <option value="HARIRA">HARIRA</option>
                            <option value="TAGINE">TAGINE</option>
                            <option value="COUSCOUS">COUSCOUS</option>
                            <option value="DESSERTS">DESSERTS</option>
                        </select>
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="price" className="text-lg font-medium text-[#2c3e50] mb-2">Price</label>
                        <input
                            type="number"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            placeholder="Enter Price"
                            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4335A7] transition duration-200 shadow-lg"
                            min="0"
                            required
                        />
                    </div>
                </div>
                <div className="flex flex-col">
                    <label htmlFor="logo" className="text-lg font-medium text-[#2c3e50] mb-2">Meal/Drink Logo</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="w-full p-4 border border-gray-300 rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#4335A7] transition duration-200 hover:bg-gray-200 cursor-pointer shadow-lg"
                    />
                </div>
                <button type="submit" className="w-full bg-[#4335A7] text-white p-4 rounded-lg text-lg hover:bg-[#5a3fbb] transition duration-200 shadow-lg hover:shadow-xl">
                    Add Meal/Drink
                </button>
            </form>
        </div>
    );
}

export default AddMeal;
